import {api, ApiResponse} from "./api";

export interface Produit {
  id: number;
  libelle: string;
  description?: string;
  prix: string; // Le prix est renvoyé comme une chaîne par Laravel
  image_url?: string;
  stock?: {
    id: number;
    produits_id: number;
    quantite: number;
  };
  prix_num: number;
  quantite: number;
  stockDisponible: number;
}

export interface UpdateProduitPayload {
  libelle?: string;
  description?: string;
  prix?: number; // envoyé en nombre au backend
  quantite?: number; // stock à jour
  image_url?: string;
}

export const getProduits = async (): Promise<Produit[]> => {
  try {
    const response = await api.get<ApiResponse<Produit[]>>('/produits');
    const produits = response.data.data.map((produit) => ({
      ...produit,
      prix_num: parseFloat(produit.prix),
    }));
    return produits;
  } catch (error) {
    throw error;
  }
};

export const getProduitsHomePage = async (): Promise<Produit[]> => {
  try {
    const response = await api.get<ApiResponse<Produit[]>>('/produits');
    return response.data.data.map((produit) => ({
      ...produit,
      prix_num: parseFloat(produit.prix),
    }));

    //const response = await api.get<ApiResponse<Produit[]>>('/produits/home_page');
    //return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const updateProduit = async (
  id: number,
  payload: UpdateProduitPayload
): Promise<Produit> => {
  try {
    const response = await api.patch<ApiResponse<Produit>>(`/produits/${id}`, payload);
    const produit = response.data.data;
    return {
      ...produit,
      prix_num: parseFloat(produit.prix),
    };
  } catch (error) {
    throw error;
  }
};

export const addProduit = async (
	payload: UpdateProduitPayload
): Promise<Produit> => {
	try {
		const response = await api.post<ApiResponse<Produit>>(`/produits`, payload);
		const produit = response.data.data;
		return {
			...produit,
			prix_num: parseFloat(produit.prix),
		};
	} catch (error) {
		throw error;
	}
};